import React from 'react';
import { useTranslation } from 'react-i18next';
import { ExportOutlined } from '@ant-design/icons';
import { ContentPageHeader, ExtraHeaderPage } from '../../molecules/page-header/ContentPageHeader';
import { ACCESS_CODE } from '../../../constants/define/translation';
import { IconCreateBlack } from '../../../assets';

interface AccessCodePageHeaderProps {
  openModalGenerate: () => void;
  openModalExport: () => void;
}

export const AccessCodePageHeader = (props: AccessCodePageHeaderProps) => {
  const { t } = useTranslation(ACCESS_CODE);
  const { openModalGenerate, openModalExport } = props;

  const extra: ExtraHeaderPage[] = [
    {
      key: 1,
      text: t('btnGenerate'),
      bgWhite: 'true',
      onClick: openModalGenerate,
      icon: <IconCreateBlack />,
      className: 'btn-generate-access-code',
    },
    {
      key: 2,
      text: t('header.buttonExport'),
      icon: <ExportOutlined />,
      className: 'btn-export-access-code',
      onClick: openModalExport,
    },
  ];

  return <ContentPageHeader title={t('title')} extra={extra} />;
};
